export const enum Role {
    UNAUTHORIZED,
    /** Вилен, Михаил */
    SUPERADMIN = 1,
    /** Руслан */
    ADMIN,
    /** РОП */
    HEAD_OF_SALES,
    /** Лид логистов */
    LEAD_OF_LOGISTICIAN,
    /** Менеджер */
    MANAGER,
    /** Логист */
    LOGISTICIAN,
    /** Водитель */
    DRIVER,
    /** Сборщик мебели */
    COLLECTOR_OF_FURNITURE,
    /** Лид сборщиков */
    LEAD_OF_FURNITURE_COLLECTORS,
    /** Партнёр */
    PARTNER,
    /** Дропшиппер */
    DROP_SHIPPER,
    /** Работник склада */
    WAREHOUSE_WORKER,
    SHOP_TECH,
    DEVELOPER,
    SUPPLIER,
    CALL_CENTER_OPERATOR,
    COLD_SALES_MANAGER,
    RECLAMATION_MANAGER,
    OZON_PAYMENT_TECH,
}

export const rolesList: Readonly<Role[]> = [
    Role.SUPERADMIN,
    Role.ADMIN,
    Role.HEAD_OF_SALES,
    Role.LEAD_OF_LOGISTICIAN,
    Role.MANAGER,
    Role.LOGISTICIAN,
    Role.DRIVER,
    Role.COLLECTOR_OF_FURNITURE,
    Role.LEAD_OF_FURNITURE_COLLECTORS,
    Role.PARTNER,
    Role.DROP_SHIPPER,
    Role.WAREHOUSE_WORKER,
    Role.SHOP_TECH,
    Role.DEVELOPER,
    Role.SUPPLIER,
    Role.CALL_CENTER_OPERATOR,
    Role.COLD_SALES_MANAGER,
    Role.RECLAMATION_MANAGER,
] as const

export const rolesNameById: Readonly<Record<Role, string>> = {
    [Role.UNAUTHORIZED]: 'Гость',
    [Role.SUPERADMIN]: 'СуперАдмин',
    [Role.ADMIN]: 'Администратор',
    [Role.HEAD_OF_SALES]: 'Руководитель продаж',
    [Role.LEAD_OF_LOGISTICIAN]: 'Лид логистов',
    [Role.MANAGER]: 'Менеджер',
    [Role.LOGISTICIAN]: 'Логист',
    [Role.DRIVER]: 'Водитель',
    [Role.COLLECTOR_OF_FURNITURE]: 'Сборщик мебели',
    [Role.LEAD_OF_FURNITURE_COLLECTORS]: 'Лид сборщиков',
    [Role.PARTNER]: 'Партнёр',
    [Role.DROP_SHIPPER]: 'Дропшиппер',
    [Role.WAREHOUSE_WORKER]: 'Работник склада',
    [Role.SHOP_TECH]: 'Техническая учётка для магазина',
    [Role.DEVELOPER]: 'Разработчик',
    [Role.SUPPLIER]: 'Поставщик',
    [Role.CALL_CENTER_OPERATOR]: 'Оператор call-центра',
    [Role.COLD_SALES_MANAGER]: 'Менеджер холодных продаж',
    [Role.RECLAMATION_MANAGER]: 'Рекламационист',
    [Role.OZON_PAYMENT_TECH]: 'Техническая учётка для Ozon',
} as const

export const isValidRole = (role: any): role is Role => rolesList.includes(role)
